import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface ThemeState {
  value: string
}


const initialState: ThemeState = {
  value: '#157ef1'
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changePrimaryColor: (state, action: PayloadAction<string>) => {
      state.value = action.payload
    },
  },
})


export const {changePrimaryColor } = themeSlice.actions

export default themeSlice.reducer
